module.exports = __webpack_public_path__ + "static/media/ece3.9f4b9a1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ece3.jpg
// module id = 5822
// module chunks = 0